import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, Check } from "lucide-react";

const PremiumContext = createContext(null);
export const usePremium = () => useContext(PremiumContext);

const BENEFITS = [
  "Todas as funcionalidades do Compasso Cuidar",
  "Recursos avançados de acompanhamento entre sessões",
  "Prioridade em novidades e suporte",
];

export function PremiumProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const openPaywall = useCallback((msg) => {
    setMessage(msg || "Este recurso faz parte do Compasso Cuidar Premium.");
    setOpen(true);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      const d = e.detail;
      openPaywall(typeof d === "string" ? d : d?.message);
    };
    window.addEventListener("premium-required", handler);
    return () => window.removeEventListener("premium-required", handler);
  }, [openPaywall]);

  return (
    <PremiumContext.Provider value={{ openPaywall }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-2xl max-w-md p-0 overflow-hidden gap-0" data-testid="paywall-dialog">
          <DialogTitle className="sr-only">Compasso Cuidar Premium</DialogTitle>
          <DialogDescription className="sr-only">Assine o Premium para desbloquear todos os recursos. Os conteúdos educacionais são sempre gratuitos.</DialogDescription>
          <div className="p-6 text-white" style={{ background: "linear-gradient(120deg,#0F766E,#1F3B4D)" }}>
            <div className="flex items-center gap-2 text-[#34D399] text-xs font-semibold uppercase tracking-wider">
              <Sparkles size={14} /> Compasso Cuidar Premium
            </div>
            <h2 className="font-heading text-xl font-bold mt-2 leading-snug">{message}</h2>
          </div>
          <div className="p-6 space-y-3">
            {BENEFITS.map((b) => (
              <div key={b} className="flex items-start gap-2 text-sm text-[#1F3B4D]">
                <Check size={18} className="text-[#0F766E] shrink-0 mt-0.5" /> {b}
              </div>
            ))}
            <p className="text-xs text-[#94A3B8] pt-1">
              A assinatura é realizada no app iOS/Android. Todos os conteúdos educacionais continuam gratuitos.
            </p>
            <div className="flex gap-2 pt-2">
              <Button data-testid="paywall-subscribe-button" className="flex-1 rounded-full bg-[#0F766E] hover:bg-[#0d6259]"
                onClick={() => setOpen(false)}>Assinar Premium</Button>
              <Button data-testid="paywall-close-button" variant="ghost" className="rounded-full" onClick={() => setOpen(false)}>
                Agora não
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </PremiumContext.Provider>
  );
}
